var map = {
	"./coursera-01.png": 92,
	"./datacamp-01.png": 93,
	"./iiitb-01.png": 94,
	"./iitg.png": 95,
	"./problem-01.png": 96,
	"./python-01.png": 97,
	"./simplilearn-01.png": 98,
	"./tabana-01.png": 99,
	"./tabcon-01.png": 100,
	"./udemy-01.png": 101,
	"./upgrad-01.jpg": 102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91;